"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMouseWheel = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

function useMouseWheel() {
  var _a = React.useState(0),
      scrolledBy = _a[0],
      setScrolledBy = _a[1];

  React.useEffect(function () {
    if (utils_1.isBrowser) {
      var onWheelScroll_1 = function onWheelScroll_1(event) {
        setScrolledBy(event.deltaY + scrolledBy);
      };

      window.addEventListener('wheel', onWheelScroll_1, false);
      return function cleanup() {
        window.removeEventListener('wheel', onWheelScroll_1, false);
      };
    }
  });
  return scrolledBy;
}

exports.useMouseWheel = useMouseWheel;